import { defaultDisabilityFormValues, DisabilityFormValues } from "./DisabilityFormValues";
import { defaultPhysicianFormValues, PhysicianFormValues } from "../common/PhysicianFormValues";
import { Medication } from "../domain/Medication";
import { Procedure } from "../domain/Procedure";
import { Referral } from "../domain/Referral";
import { SicknessType } from "../enums/SicknessType";

export type DisabilityPhysicianFormValues = PhysicianFormValues & DisabilityFormValues & {
    physicianFaxNumber: string,
    formCompleterName: string,
    sicknessType: SicknessType,
    workRelated: string,
    medications: Medication[],
    surgeries: Procedure[],
    therapies: Procedure[],
    referrals: Referral[],
}

export const defaultDisabilityPhysicianFormValues = {
    ...defaultPhysicianFormValues,
    ...defaultDisabilityFormValues,
    physicianFaxNumber: '',
    formCompleterName: '',
    sicknessType: '',
    workRelated: '',
    medications: [],
    surgeries: [],
    therapies: [],
    referrals: [],
}